(function ($) {
    $.fn.overflowHover = function () {
        return this.each(function () {
            var $this = $(this);
            $this.hover(function () {
                if ($this.has(':checkbox:disabled').size() == 0) {
                    var $clone = $this.clone().insertBefore($this);
                    // Make sure the original is on top so that form fields work
                    $this.css({'z-index': 100000});
                    $clone.addClass('overflow-hover');
                    $clone.find('label').attr('for', '_dummy');
                    $clone.find('input').attr('id', '_dummy');
                    // make it absolute so that it appears over the original, and make text transparent to avoid ghosting
                    $clone.css({position: 'absolute', 'z-index': 10000, color: 'transparent'});
                    // Make all contents invisible to avoid ghosting
                    $clone.find('*').css({visibility: 'hidden'});
                }
            }, function () {
                if ($this.has(':checkbox:disabled').size() === 0) {
                    $this.prev('.overflow-hover').remove();
                }
            });
        });
    };
})(jQuery);